import { Point as PointScale } from '@antv/scale';
export const Point = (options) => {
    return new PointScale(options);
};
Point.props = {};
//# sourceMappingURL=point.js.map